import React, { ReactNode } from 'react';
import { FieldRenderProps } from 'react-final-form';

type Props = {
  placeholder: React.ReactNode;
  fieldType?: string;
  required?: boolean;
  name: string,
  value: boolean,
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
};

type State = {
};

class CheckboxInput extends React.Component<Props, State> {
  static defaultProps = {
    fieldType: 'checkbox',
    required: false,
  };

  state: State = {
  };

  render(): ReactNode {
    const htmlFor = this.props.name;
    return (
      <div className="checkbox-input-group">
        <input
          type="checkbox"
          className="checkbox-input-field"
          checked={this.props.value}
          onChange={this.props.onChange}
          id={htmlFor}
          required={this.props.required}
        />
        <label htmlFor={htmlFor} className="checkbox-input-placeholder">{this.props.placeholder}</label>
      </div>
    );
  }
}

export default CheckboxInput;
